var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 20.3251V36.6311C23.696 36.7066 23.7123 36.7819 23.7474 36.8489C23.7825 36.9159 23.835 36.9722 23.8995 37.0119C23.9639 37.0515 24.0378 37.073 24.1135 37.0741C24.1891 37.0752 24.2636 37.0559 24.3292 37.0181L37.2572 28.8631C37.3205 28.8209 37.3724 28.7637 37.4083 28.6967C37.4443 28.6296 37.463 28.5547 37.463 28.4786C37.463 28.4025 37.4443 28.3276 37.4083 28.2605C37.3724 28.1935 37.3205 28.1363 37.2572 28.0941L24.3292 19.9401C24.264 19.901 24.1893 19.8805 24.1133 19.8809C24.0373 19.8812 23.9629 19.9024 23.898 19.942C23.8332 19.9817 23.7805 20.0384 23.7456 20.1059C23.7107 20.1735 23.695 20.2493 23.7002 20.3251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.811 0.711C22.3292 0.71611 16.0484 2.96134 11.0322 7.06646C6.01603 11.1716 2.57287 16.8842 1.28582 23.237C-0.00122595 29.5897 0.946957 36.1921 3.96979 41.9259C6.99262 47.6597 11.9043 52.1725 17.873 54.7C24.726 57.527 32.4185 57.5321 39.2753 54.7143C46.1321 51.8964 51.598 46.4837 54.4829 39.6549C57.3677 32.826 57.4379 25.1339 54.6782 18.2535C51.9184 11.3731 46.5522 5.86155 39.748 2.919C36.288 1.4547 32.5681 0.703708 28.811 0.711ZM28.811 0C34.5093 0 40.0796 1.68974 44.8175 4.85553C49.5555 8.02132 53.2483 12.521 55.4289 17.7855C57.6095 23.05 58.1801 28.843 57.0684 34.4317C55.9567 40.0205 53.2127 45.1542 49.1835 49.1835C45.1542 53.2127 40.0205 55.9567 34.4317 57.0684C28.843 58.1801 23.05 57.6095 17.7855 55.4289C12.521 53.2483 8.02132 49.5555 4.85553 44.8175C1.68974 40.0796 0 34.5093 0 28.811C0 21.1698 3.03544 13.8417 8.43855 8.43855C13.8417 3.03544 21.1698 0 28.811 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.621,
    height: 57.621,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayWhite);
export default __webpack_public_path__ + "static/media/video_play_white.d86add7f63f41cafe1a92f0f26e8ee15.svg";
export { ForwardRef as ReactComponent };